import type { ReactNode } from "react";

export interface LegendItem {
	key: string;
	label: ReactNode;
	color: string;
	/** `line` for a marker that is a line (the "due" tick), `swatch` (default) for a fill. */
	shape?: "swatch" | "line";
	/** A count beside the label. */
	value?: ReactNode;
}

/**
 * A chart's legend — always present for two or more series: identity never
 * rests on colour alone. Text in ink / muted; the colour is the swatch's.
 */
export function Legend({ items, className = "" }: { items: readonly LegendItem[]; className?: string }) {
	return (
		<ul className={`flex flex-wrap items-center gap-x-[1rem] gap-y-[0.375rem] text-[0.8125rem] text-muted ${className}`}>
			{items.map((i) => (
				<li key={i.key} className="inline-flex items-center gap-[0.375rem]">
					{i.shape === "line" ? (
						<span aria-hidden="true" className="h-[2px] w-[0.875rem] shrink-0 rounded-full" style={{ background: i.color }} />
					) : (
						<span aria-hidden="true" className="size-[0.625rem] shrink-0 rounded-[0.1875rem]" style={{ background: i.color }} />
					)}
					<span className="text-ink">{i.label}</span>
					{i.value !== undefined && <span className="font-mono tabular-nums">{i.value}</span>}
				</li>
			))}
		</ul>
	);
}
